// extracted by mini-css-extract-plugin
export default {"container":"ProductImageZoom_container__HMi2e","zoom":"ProductImageZoom_zoom__EW1-0","zoomIcon":"ProductImageZoom_zoomIcon__fvD8-","closeIcon":"ProductImageZoom_closeIcon__SY6l2"};